<template>
  <div class="home">
    <section class="logo">
      <img alt="Logo" src="../assets/logo.svg">
    </section>
    <container class="buttons">
      <router-link :to="{name: 'game'}" tag="button"><img src="../assets/svg/play.svg"><span>play</span></router-link>
      <router-link :to="{name: 'settings'}" tag="button"><img src="../assets/svg/settings.svg"><span>settings</span></router-link>
      <router-link :to="{name: 'about'}" tag="button"><img src="../assets/svg/info.svg"><span>about</span></router-link>
    </container>
  </div>
</template>

<script>
    // @ is an alias to /src
    import Container from "@/components/container";

    export default {
        name: 'Home',
        components: {
            Container,
        }
    }
</script>

<style lang="scss">
  @import "src/assets/colors.scss";
  .home {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    min-height: 100%;
    flex: 1
  }

  .logo {
    padding: 50px 75px;
    max-width: 400px;
    img {
      margin: auto 0;
      width: 100%;
    }
    h1 {
      font-size: xx-large;
      margin-bottom: 0;
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;

    button {
      background: none;
      display: flex;
      justify-content: start;
      align-items: center;
      font-size: large;
      border-radius: 10px;
      border: none;
      height: 40px;
      min-width: 120px;
      margin: 5px 0;
      line-height: 32px;

      img {
        height: 32px;
        margin-right: 10px;
      }
    }
  }
</style>